export default {
  addGoogleMaps: function(API_KEY) {
    const script = document.createElement('script')
    script.async = true
    script.defer = true
    script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}`;
    document.querySelector('head').appendChild(script)

    return true
  }
}
